/**
 * WorkloadIndicator Component
 * AIDLC Administrative Backend
 *
 * Visual workload bar for agent utilization in the allocation matrix.
 * Shows percentage as a filled bar with color coding:
 *   0-60% = green, 61-80% = yellow, 81-100% = red
 */

interface WorkloadIndicatorProps {
  utilization: number;
  className?: string;
}

export function WorkloadIndicator({ utilization, className = '' }: WorkloadIndicatorProps) {
  const pct = Math.min(100, Math.max(0, utilization));

  const barColor =
    pct > 80 ? 'bg-red-500' :
    pct > 60 ? 'bg-yellow-500' :
    'bg-green-500';

  const textColor =
    pct > 80 ? 'text-red-700' :
    pct > 60 ? 'text-yellow-700' :
    'text-green-700';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden min-w-[60px]">
        <div
          className={`h-full rounded-full transition-all duration-300 ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={`text-xs font-medium ${textColor} min-w-[36px] text-right`}>
        {pct}%
      </span>
    </div>
  );
}
